import React, { useEffect, useRef, useState } from "react";
import { Flex } from "../Flex/Flex";
import { View } from "../View/View";
import { v4 as uuidv4 } from "uuid";
import { RawTooltip } from "../Tooltip";
import { useSubSection } from "../SubSection";
import { TMS_THEME } from "../theming/theming";
import { useAgendaStyles } from "./Agenda.styles";
import { useUtilityStyles, UtilityStyle } from "../hooks/useUtilityStyles";
import { classNames } from "../utils/classNames";
import { Prompt } from "../Prompt";
const AgendaRaw = (props) => (React.createElement(Flex, { direction: "column", role: "list" },
    props?.children,
    props?.data?.map((row, i) => {
        return React.createElement(AgendaRow, { ...row, key: i });
    })));
const AgendaRow = (row) => {
    const { show, toggleOpen } = useSubSection(!!row?.children);
    const componentId = uuidv4();
    const classes = useAgendaStyles(row);
    return (React.createElement(View, { role: "listitem" },
        row?.children === undefined ? (React.createElement(PrimaryContent, { ...row, extra: undefined })) : (React.createElement("div", { onClick: () => toggleOpen(), role: "button", onKeyPress: () => toggleOpen(), tabIndex: 0, "aria-expanded": show === "open", "aria-controls": componentId },
            React.createElement(PrimaryContent, { ...row, extra: show }))),
        (show === "opening" || show === "open") && (React.createElement("div", { id: componentId, className: classes.subSectionContainer }, row?.children))));
};
const AgendaAlert = (alertRow) => {
    const getBgType = (type) => {
        const typeMap = {
            success: "success",
            info: "info",
            warning: "warning",
            error: "danger",
        };
        return typeMap[type];
    };
    return (React.createElement("div", { className: `bg-${getBgType(alertRow.type)}`, style: { "--bs-bg-opacity": 0.1 } },
        React.createElement("div", { style: { padding: "5px 0px 0px 10px" } },
            React.createElement(Prompt, { type: alertRow.type, message: alertRow.alertMessage })),
        alertRow.children));
};
const PrimaryContent = (row) => {
    const wrapperRef = useRef(null);
    const [ellipseContent, setEllipseContent] = useState(false);
    const overflowTooltipId = uuidv4();
    useEffect(() => {
        const currentElement = wrapperRef.current && wrapperRef.current.offsetHeight;
        if (!ellipseContent && currentElement !== null && currentElement > 21) {
            setEllipseContent(true);
        }
    }, [wrapperRef.current]);
    const classes = useAgendaStyles(row);
    const utilityClasses = useUtilityStyles([
        { bold: [UtilityStyle.FontBold] },
        { flex1: [UtilityStyle.FlexOne] },
    ]);
    return (React.createElement("div", { style: row?.extra === "open"
            ? { backgroundColor: TMS_THEME.palette.gray.aliceBlue.color }
            : {} },
        React.createElement(View, { paddingTop: "small", paddingBottom: "medium", hover: row?.extra !== undefined ? "aliceBlue" : undefined },
            React.createElement(Flex, null,
                row?.indicator && (React.createElement("div", { className: classes.indicatorContainer },
                    React.createElement(Flex, { justifyContent: "end" },
                        React.createElement("div", { className: classes.indicator })))),
                React.createElement("div", { className: classes.datetimeContainer },
                    React.createElement(Flex, { direction: "column" },
                        React.createElement("div", null, row.time),
                        row.secondaryTime && (React.createElement("div", { className: `${classes.elementHeight} ${classes.metaInformation}` }, row.secondaryTime)))),
                React.createElement("div", { "data-tip": !!ellipseContent, "data-for": overflowTooltipId, className: utilityClasses.flex1, id: `anchor_${overflowTooltipId}` },
                    React.createElement("div", { ref: wrapperRef, className: classNames(ellipseContent ? "ellipse-content line-clamp-one" : undefined, utilityClasses.bold) }, row.description),
                    row.metaInformation && (React.createElement("div", { className: `${classes.elementHeight} ${classes.metaInformation}` }, row.metaInformation)),
                    ellipseContent && (React.createElement(RawTooltip, { anchorId: `anchor_${overflowTooltipId}`, content: row.description }))),
                row.extra !== undefined && (React.createElement("div", { className: classes.arrowContainer },
                    React.createElement("span", { className: `sub-section-header-indicator glyphicon glyphicon-chevron-right ${row.extra}` })))))));
};
export const Agenda = Object.assign(AgendaRaw, {
    Row: AgendaRow,
    Alert: AgendaAlert,
});
